import { EnvelopeSimple, PaperPlaneTilt, WhatsappLogo } from '@phosphor-icons/react'
import { CONTACTS } from './contacts'

const CONTACT_ICONS = {
  telegram: PaperPlaneTilt,
  whatsapp: WhatsappLogo,
  email: EnvelopeSimple,
}

export default function ContactLinks({ variant = 'default', showHeading = false }) {
  return (
    <section className={`contact-links contact-links-${variant}`} aria-label="Связаться с Владиславом">
      {showHeading ? (
        <div className="contact-links-heading">
          <span>Обсудить проект</span>
          <strong>Выберите удобный канал связи</strong>
        </div>
      ) : null}
      <nav>
        {Object.entries(CONTACTS).map(([key, contact]) => {
          const Icon = CONTACT_ICONS[key]
          const externalProps = key === 'email' ? {} : { target: '_blank', rel: 'noreferrer' }
          return (
            <a href={contact.href} key={key} {...externalProps}>
              <Icon weight={key === 'telegram' ? 'fill' : 'regular'} aria-hidden="true" />
              <span>
                <small>{contact.label}</small>
                <strong>{contact.value}</strong>
              </span>
            </a>
          )
        })}
      </nav>
    </section>
  )
}
